<div kalDialogContent [formGroup]="form">

    <div class="flexLine">

        <kal-button *ngFor="let node of ruleComputationList"
                    (click)="selectNode(node)"
                    [kalTheme]="node === selectedNode ? 'primary' : 'tertiary'"
                    [ngSwitch]="node.type">

            <ng-container *ngSwitchCase="ComputationNodeType.Operateur">
                {{node.Operateur.Libelle}}
            </ng-container>

            <ng-container *ngSwitchCase="ComputationNodeType.Critere">
                {{node.Critere.Libelle}}
            </ng-container>

            <ng-container *ngSwitchCase="ComputationNodeType.Valeur">
                {{node.Valeur}}
            </ng-container>

        </kal-button>

    </div>

    <div class="flexLine">
        <a (click)="openLinearFormulaDialog()" class="gup-O-link -secondary">Utiliser une formule de calcul linéaire</a>
        <a (click)="removeNode()" class="gup-O-link -secondary">Supprimer l'élément</a>
    </div>

    <div class="gup-U-margin-bottom--normal">

        <label>Ajouter un symbole</label>

        <div class="flexLine">

            <kal-button kalTheme="tertiary"
                        *ngFor="let operator of operatorList"
                        (click)="addOperator(operator.value)">
                {{operator.label}}
            </kal-button>

        </div>

    </div>

    <div>

        <kal-form-field>

            <kal-select formControlName="criterion" label="Ajouter un critère">

                <kal-option [class.gup-U-color--red]="criterion.PossedeDesParametres"
                            *ngFor="let criterion of criteriaList" [value]="criterion">
                    {{criterion.Libelle}}
                </kal-option>

            </kal-select>

            <div class="flexLine">

                <a class="gup-O-link -secondary" (click)="addCriterion({isAfter: false})">Ajouter avant</a>
                <a class="gup-O-link -secondary" (click)="addCriterion({isAfter: true})">Ajouter après</a>

            </div>

        </kal-form-field>

        <app-shared-advanced-rule-criterion-parameters-control class="gup-C-flexGroup__item -demi"
                                                                 *ngIf="shouldDisplayParams"
                                                                 [criterionId]="form.get('criterion').value?.Id"
                                                                 formControlName="parametersList">
        </app-shared-advanced-rule-criterion-parameters-control>

    </div>

    <kal-form-field>

        <kal-input formControlName="value" label="Ajouter une valeur">
        </kal-input>

        <div class="flexLine">
            <a class="gup-O-link -secondary" (click)="addValue({isAfter: false})">Ajouter avant</a>
            <a class="gup-O-link -secondary" (click)="addValue({isAfter: true})">Ajouter après</a>
        </div>

    </kal-form-field>

    <ul *ngIf="errors | arrayNotEmpty" class="gup-U-color--red">
        <li *ngFor="let error of errors">{{errors}}</li>
    </ul>

</div>


<div kalDialogFooter>
    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">
            <kal-button [disabled]="errors | arrayNotEmpty"

                        kalTheme="primary"
                        (click)="submit()">
                Valider
            </kal-button>
        </div>

        <div class="gup-O-list__item">
            <kal-button (click)="close()"
                        kalTheme="secondary">
                Fermer sans enregistrer
            </kal-button>
        </div>

    </div>
</div>
